import React from "react";
import Icon from "../Icon";
import Button from "react-bootstrap/Button";

export interface IconButtonProps {
	ref?: React.MutableRefObject<HTMLButtonElement>;
	icon: string;
	onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
	ariaLabel: string;
	classes?: string;
	disabled?: boolean;
	busy?: boolean;
	customBusyIcon?: React.ReactNode;
	type?: "light" | "regular" | "solid" | "brand" | "duotone";
}

const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
	({ icon, onClick, ariaLabel, classes, disabled, busy, customBusyIcon, type }, ref) => {
		return (
			<Button
				ref={ref}
				variant="plain"
				className={`icon-btn ${classes ?? ""} ${busy ? "busy" : ""}`}
				aria-label={ariaLabel}
				onClick={onClick}
				disabled={disabled ?? false}
			>
				{customBusyIcon ? (
					<>{busy ? customBusyIcon : <Icon icon={icon}></Icon>}</>
				) : (
					<Icon icon={busy ? "spinner-third" : icon} classes={busy ? "fa-spin" : ""} type={type}></Icon>
				)}
			</Button>
		);
	}
);

export default IconButton;
